import {
  ADMIN_TAXES_RECEIVED,
  ADMIN_TAXES_UPDATED,
  ADMIN_TAXES_UNLOADED
} from './types'

export default function settings(state = {}, action = {}){
  switch (action.type) { 
    case ADMIN_TAXES_RECEIVED:
      return action.taxes
    case ADMIN_TAXES_UPDATED:
      const i = state.findIndex(t=>t.id===action.tax.id)
      state[i] = action.tax      
      return state
    case ADMIN_TAXES_UNLOADED:
      return []
    default:
      return state
  }
}